import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20artistic%20abstract%20composition%20with%20flowing%20gradient%20waves%20of%20warm%20orange%20and%20soft%20cream%20tones%2C%20geometric%20shapes%20floating%20in%20a%20minimalist%20style%2C%20modern%20digital%20art%2C%20smooth%20curves%2C%20clean%20aesthetic%2C%20light%20airy%20feel%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="香蕉视频 - 短视频创作与分享平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="香蕉视频 - 短视频创作与分享平台"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            发现有趣视频，展示自我才华
          </h1>
          <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
            香蕉视频——专为内容创作者打造的短视频分享平台。<br className="hidden sm:block" />
            海量原创内容、智能推荐算法，让每个有趣的灵魂都被看见。
          </p>

          {/* Search Bar */}
          <div className="flex items-center max-w-lg mx-auto bg-background-50 rounded-full overflow-hidden shadow-lg">
            <div className="flex items-center pl-5">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索你感兴趣的视频..."
              className="flex-1 px-3 py-3.5 text-sm text-foreground-900 bg-transparent outline-none border-none placeholder:text-foreground-400"
            />
            <button className="whitespace-nowrap px-6 py-3.5 bg-[oklch(var(--primary-500))] text-background-50 text-sm font-medium hover:bg-[oklch(var(--primary-500)/0.85)] transition-colors cursor-pointer">
              搜索
            </button>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-center gap-10 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>500万+</p>
              <p className="text-xs text-background-50/70 mt-1">活跃创作者</p>
            </div>
            <div className="w-px h-10 bg-background-50/25"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>2亿+</p>
              <p className="text-xs text-background-50/70 mt-1">原创视频</p>
            </div>
            <div className="w-px h-10 bg-background-50/25"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>8000万+</p>
              <p className="text-xs text-background-50/70 mt-1">日活用户</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}